module.exports = __webpack_public_path__ + "static/media/persistent_cookie.8124aad4.svg";